import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import DlGroupList from "./pages/dl_group/DlGroupList";
import AdminPhotoSeries from "./pages/photo_series/AdminPhotoSeries";
import AdmStart from "./pages/common/AdmStart";
import AdminLayout from "./layout/AdminLayout";
import { useAuthCurrent } from "hooks/auth/auth_current";
import { AddNavigationProvider } from "common/modal/AddNavigation";
import AdminPhotoSeriesEdit from "./pages/photoSeries/AdminPhotoSeriesEdit";
import Users from "./pages/user/Users";
import UserEdit from "./pages/user/UserEdit";
import UserNew from "./pages/user/UserNew";
import DlGroupNew from "./pages/dl_group/DlGroupNew";
import DlGroupEdit from "./pages/dl_group/DlGroupEdit";
import DlUnitNew from "./pages/dl_unit/DlUnitNew";
import DlUnitList from "./pages/dl_unit/DlUnitList";
import DlUnitEdit from "./pages/dl_unit/DlUnitEdit";

export default function AdmApp() {
  const authCurrent = useAuthCurrent();
  const navigate = useNavigate();
  useEffect(() => {
    // console.log("authCurrent", authCurrent);
    if (!authCurrent || !authCurrent.un || authCurrent.un === "") {
      navigate("/l-in");
    }
  }, [authCurrent]);

  return (
    <AddNavigationProvider>
      <Routes>
        <Route element={<AdminLayout />}>
          <Route path="/" element={<DlUnitList />} />
          {/* <Route path="l-out" element={<ToLogout />} /> */}
          <Route path="dl-group-li" element={<DlGroupList />} />
          <Route path="dl-group-new" element={<DlGroupNew />} />
          <Route path="dl-group-edit/:itemId" element={<DlGroupEdit />} />
          <Route path="photo-ser-li" element={<AdminPhotoSeries />} />
          <Route path="photo-ser-edit" element={<AdminPhotoSeriesEdit />} />
          <Route path="user-li" element={<Users />} />
          <Route path="user-edit/:itemId?" element={<UserEdit />} />
          <Route path="user-new" element={<UserNew />} />
          <Route path="dl-unit-li" element={<DlUnitList />} />
          <Route path="dl-unit-new" element={<DlUnitNew />} />
          <Route path="dl-unit-edit/:itemId" element={<DlUnitEdit />} />
        </Route>
      </Routes>
    </AddNavigationProvider>
  );
}
